import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MessageSquare, CheckCircle2, AlertCircle, Phone } from "lucide-react";

export default function AdminSmsLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/admin/sms-logs").then((r) => setLogs(r.data));
  }, []);

  return (
    <div data-testid="admin-sms-page">
      <h1 className="font-display text-4xl uppercase">SMS Log</h1>
      <p className="text-sm text-neutral-400 mt-1 mb-8">Toate SMS-urile trimise catre clienti</p>

      <div className="space-y-2">
        {logs.length === 0 && (
          <div className="bg-neutral-950 border border-neutral-800 p-12 text-center text-neutral-500">Niciun SMS trimis inca</div>
        )}
        {logs.map((l) => {
          const success = ["sent", "queued", "delivered", "mocked"].includes(l.status);
          return (
            <div key={l.id} data-testid={`sms-log-${l.id}`} className="bg-neutral-950 border border-neutral-800 p-4 flex gap-4">
              <div className={`w-10 h-10 flex items-center justify-center flex-shrink-0 ${success ? "bg-[#00E5FF]/10 border border-[#00E5FF]/30" : "bg-red-500/10 border border-red-500/30"}`}>
                {success ? <CheckCircle2 className="w-5 h-5 text-[#00E5FF]" /> : <AlertCircle className="w-5 h-5 text-red-500" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 flex-wrap mb-1">
                  <span className="flex items-center gap-1 text-sm text-white"><Phone className="w-3 h-3 text-[#00E5FF]" /> {l.phone}</span>
                  <span className={`text-[10px] uppercase tracking-widest px-2 py-0.5 ${l.mode === "mock" ? "bg-amber-500/20 text-amber-400" : "bg-green-500/20 text-green-400"}`}>{l.mode}</span>
                  <span className="text-[10px] uppercase tracking-widest text-neutral-400">{l.status}</span>
                </div>
                <p className="text-sm text-neutral-300">{l.message}</p>
                <div className="text-xs text-neutral-500 mt-1">{new Date(l.timestamp).toLocaleString("ro-RO")}</div>
                {l.error && <div className="text-xs text-red-400 mt-1">{l.error}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
